import { makeRequest } from 'utils/requestLogger';

export default (id,payload) => makeRequest('post', `/api/courses/${id}/admin-subscription`,payload);



// WEBPACK FOOTER //
// ./src/app/services/courses/createAdminSubscription.js